import { actionTypes, mutationTypes, situacoes } from '@/core/constants'
import descriptografaHash from '@/views/pages/adesao/anuenciaFornecedor/mixin/DescriptografaHash'
import store from '@/core/store'

export default {
	mixins: [descriptografaHash],
	async mounted() {
		await this.buscarDadosCabecalho()
	},
	computed: {
		estaRecusada() {
			return this.anuencia.situacaoItemAdesao === situacoes.ADESAO.RECUSADO.value
		},
		estaAceita() {
			return this.anuencia.situacaoItemAdesao === situacoes.ADESAO.ACEITO.value
		},
		estaAssinado() {
			return this.anuencia.situacaoItemAdesao === situacoes.ADESAO.ASSINADO.value
		},
		finalizado() {
			return this.anuencia.situacaoItemAdesao === situacoes.ADESAO.CONCLUIDO.value
		},
		isAdesaoConcluida() {
			return this.anuencia.situacaoAdesao === situacoes.ADESAO.CONCLUIDO.value
		},
	},
	methods: {
		async buscarDadosCabecalho() {
			this.anuencia = await this.$store.dispatch(
				actionTypes.ANUENCIA.BUSCAR_DADOS_CABECALHO,
				this.getControleAnuencia(),
			)

			this.$store.commit(mutationTypes.CASAS_DECIMAIS.SET_CASAS_DECIMAIS, {
				qtd: this.anuencia.numeroCasasDecimaisQtde,
				valor: this.anuencia.numeroCasasDecimaisValores,
			})
		},
	},
}
